import React from 'react'
import {Popover, Tag} from 'antd'
import {getCorpTagIds} from 'crm/components/tags-modal/utils'

import styles from './page.less'

export function renderTags(tags, hasStatus) {
    if (hasStatus) {
        return (
            <div className={styles.tags}>
                {tags.map((tag, index) => {
                    const {name, updating} = tag
                    return (
                        <Tag
                            key={index}
                            className={`${styles.tag} ${updating ? styles.updating : ''}`}
                        >
                            {name}
                        </Tag>
                    )
                })}
            </div>
        )
    }
    return (
        <div className={styles.tags}>
            {tags.map((tag, index) => (
                <Tag key={index} className={styles.tag}>
                    {tag}
                </Tag>
            ))}
        </div>
    )
}

export function renderTagColumn(tags, hasStatus) {
    if (Array.isArray(tags) && tags.length) {
        const len = tags.length
        if (len <= 10) {
            return renderTags(tags, hasStatus)
        }
        return (
            <Popover
                placement="top"
                content={<div className={styles.wholeTags}>{renderTags(tags, hasStatus)}</div>}
                title={null}
                trigger="hover"
            >
                {renderTags(tags.slice(0, 10), hasStatus)}
            </Popover>
        )
    }
}

export function renderDepartments(departments = []) {
    let content = '- -'

    if (departments && departments.length) {
        content = departments.map((item, index) => (
            <React.Fragment key={`${item.name}_${index}`}>
                {item.name}
                {index === departments.length - 1 ? '' : ', '}
            </React.Fragment>
        ))
    }
    return content
}

export function filterEmptyArrParams(key, query) {
    if (query.hasOwnProperty(key)) {
        if (!query[key]?.length) {
            delete query[key]
        }
    }
}

export function filterTagParams(key, query) {
    if (query.hasOwnProperty(key)) {
        if (!query[key]?.values?.length) {
            delete query[key]
            return
        }
        if (key === 'corp_tags' || key === 'corp_tags2') {
            query[key].values = getCorpTagIds(query[key].values)
        }
    }
}
